<template>
  <div>
    <button class="btn btn-sm btn-outline--info mt-2" @click.prevent="showEdit">Edit</button>
  </div>
</template>

<script>

export default {
  name: "edit-item",
  props: {
    item_id: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
    
    };
  },
  created() {
  },
  methods: {
    showEdit() {
      const url = '/creator/video-item-edit/' + this.item_id;
      window.location = url;
    },
   
  },
};
</script>
